<script setup lang="ts">
  import { computed, useId } from 'vue';
  import type { RecordListProps } from './RecordList.types';
  import { recordListRootClass } from './RecordList.css';

  const props = defineProps<RecordListProps>();

  const uid = useId();
  const resolvedTestId = computed(
    () => props.testId ?? `ds-record-list-${uid}`,
  );
</script>

<template>
  <div :class="recordListRootClass" :data-testid="resolvedTestId"><slot /></div>
</template>
